import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_attribute_set_hdr_RowClass } from '../../../dbschema/bl_fi_mst_attribute_set_hdr.model';
import { bl_fi_mst_attribute_set_ext_RowClass } from '../../../dbschema/bl_fi_mst_attribute_set_ext.model';

export class AttributeSetContainerModel extends BaseContainerModel {
  bl_fi_mst_attribute_set_hdr: bl_fi_mst_attribute_set_hdr_RowClass = new bl_fi_mst_attribute_set_hdr_RowClass();
  bl_fi_mst_attribute_set_ext: bl_fi_mst_attribute_set_ext_RowClass[] = [];
}